module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-invisalign-consult"
  }, [_c('div', {
    staticClass: "custom-invisalign-consult__container"
  }, [_c('div', {
    staticClass: "custom-invisalign-consult__container--text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  }), _c('div', {
    staticClass: "custom-invisalign-consult__container--button"
  }, [_c('div', {
    staticClass: "custom-invisalign-consult__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": function($event) {
        return _vm.showModal(0)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a5d12f5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-invisalign-consult/custom-invisalign-consult.pug
// module id = 661
// module chunks = 1